import { settingsActions } from '../reducers/settings';

export const {
  setApiVerbose,
  setConfiguration,
  setSetting,
  setStyle,
  setTranslation,
  setTimeZone,
  setUrlParam,
} = settingsActions;
